module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetLow@2x.eacdb30.webp";